import { FetchState } from '@/types/fetchState';
import { defineStore } from 'pinia';
import { generateAPI } from '@/shared/lib';
import { AllResultsResponse } from '@/generated/src';

// APIの戻り値の型（AllResultsResponseと同じ構造）

export const useCustomCalcResultAllStore = defineStore('customCalcResultAll', {
  state: (): FetchState<AllResultsResponse> => ({
    data: null,
    loading: false,
    error: null,
  }),

  getters: {
    /**
     * データが存在するかどうか
     */
    hasData: (state): boolean => state.data !== null,

    /**
     * エラーメッセージ
     */
    errorMessage: (state): string | null => state.error?.message ?? null,

    /**
     * 全結果データ
     */
    allResults: (state): AllResultsResponse | null => state.data ?? null,
  },

  actions: {
    /**
     * customCalcの全結果データを取得
     */
    async fetch(basinId: string, filename: string) {
      this.loading = true;
      this.error = null;

      try {
        this.data = await generateAPI().customCalcApi.customCalcAllResultsApiApiCustomCalcResultBasinIdAllGet({
          basinId,
          filename,
        });
      } catch (error) {
        this.data = null;
        this.error = error as Error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    /**
     * データをクリア
     */
    clear() {
      this.data = null;
      this.error = null;
    },
  },
});
